<template>
  <li>
    <router-link :to="route">
      <div class="row align-items-center">
        <div class="col">
          <p class="strong">Placement {{ placement.number }}</p>
        </div>
        <div class="col-auto">
          <p class="text-muted">
            <span class="data-label d-lg-none">Placement Dates:</span>
            {{ startDate }} to {{ endDate }}
          </p>
        </div>
      </div>

      <ul class="details">
        <li>Department: {{ placement.agency ? placement.agency.name : 'Unassigned' }}</li>
        <li>Manager: {{ placement.manager ? placement.manager.name : 'Unassigned' }}</li>
        <li>
          <span
            v-if="placement.previous_underperforming"
            class="badge badge-warning"
            data-toggle="tooltip"
            data-placement="top"
            title="Graduate has capabilities requiring development. See Help for information"
            @click.prevent
          >Capabilities Requiring Development</span>
        </li>
      </ul><!-- /.details -->
    </router-link>

    <button v-if="$userIsAdmin && !placement.finalised" type="button" class="btn text-muted" @click="$emit('click', placement)">
      <font-awesome :icon="['fal', 'cog']"/>
      <span class="sr-only">Edit Placement Assignments</span>
    </button>
  </li>
</template>

<script>
import { graduateComputed } from 'vx/helpers'
import moment from 'moment'

export default {
  props: {
    placement: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...graduateComputed,

    route () {
      if (this.$userIsGraduate) {
        return { name: 'placements.single', params: { placementId: this.placement.id } }
      }

      return { name: 'graduates.placements.single', params: { graduateId: this.graduate.id, placementId: this.placement.id } }
    },

    startDate () {
      if (!this.placement.start_date) {
        return 'Unknown'
      }

      return moment(this.placement.start_date).format('DD/MM/YYYY')
    },

    endDate () {
      if (!this.placement.end_date) {
        return 'Unknown'
      }

      return moment(this.placement.end_date).format('DD/MM/YYYY')
    }
  }
}
</script>
